
























import { defineComponent, toRefs, PropType, ref, computed, Ref, watch } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  DARK_POST_STATUS_MAP as DarkPostStatus,
  NATIVE_AD_ACTION_TYPE,
  PrecheckResult
} from '@tt4b/ttam-enums';
import { IdentityFullInfo } from '../../identity/types';
import TtamAffiliateLibraryVideoResultItem from './item.vue';
import { useAffiliateTikTokListDataSource } from './../../identity/hooks';

const name = 'ttam-affiliate-library-video-result-compose';
export default defineComponent({
  name,
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: Object as PropType<Ref<string>>,
    },
    originEditFormData: {
      type: Object as PropType<Partial<FullNormalFormData>>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({
        materialResults: [],
        summaryResults: [],
      }),
    },
    piniaData: {
      type: Object as PropType<{
        creatives: Ref<FullNormalFormData[]>;
        identity: Ref<IdentityFullInfo>;
      }>,
      default: () => ({}),
    },
  },
  components: {
    TtamAffiliateLibraryVideoResultItem,
  },
  setup(props, { emit }) {
    const { creativeData, campaignData, adgroupData } = toRefs(props);
    const form = ref();
    const localCreativeList = ref(
      props.piniaData.creatives.value.map(creative => ({
        ...creative,
        darkPostStatus: creativeData.value.darkPostStatus,
        title: creativeData.value.nativeAdActionType === NATIVE_AD_ACTION_TYPE.PUSH_VIDEO_TO_TTBA ? creativeData.value.title: '',
        nativeAdActionType: NATIVE_AD_ACTION_TYPE.PUSH_VIDEO_TO_TTBA,
      })),
    );
    const { tikTokAccountOriginalData } = useAffiliateTikTokListDataSource({
      campaignData,
      adgroupData,
    });
    const isNextButtonAvailable = computed(() => localCreativeList.value.every(creative => !!creative.title));
    const formdata = computed(() =>
      localCreativeList.value.reduce((pre, creative) => {
        pre[creative.videoInfo.vid] = creative.title;
        return pre;
      }, {}),
    );
    const creativeTextChangeHandler = ({ textVal, index }: { textVal: string; index: number }) => {
      localCreativeList.value[index].title = textVal;
      // @ts-ignore
      localCreativeList.value[index].videoInfo.text = textVal;
    };
    const creativeOnlyAdsChange = ({ darkPostStatus, index }: { darkPostStatus: typeof DarkPostStatus; index: number }) => {
      localCreativeList.value[index].darkPostStatus = darkPostStatus;
    };
    watch(isNextButtonAvailable, (val) => {
      emit('valid-status', val);
    })
    // next按钮默认禁用，需要init方法告诉外部将next置为可点击
    const init = () => {
      emit('valid-status', isNextButtonAvailable.value);
    }
    const next = async () => {
      // 表单校验
      await form.value?.validate?.();
      // 关闭抽屉
      emit('next', localCreativeList.value);
    };
    return {
      name,
      localCreativeList,
      tikTokAccountOriginalData,
      formdata,
      form,
      creativeTextChangeHandler,
      creativeOnlyAdsChange,
      init,
      next,
    };
  },
});
